// Пороги обратного отсчёта на экране звонка. Раньше все три момента считались от одного
// числа, из-за чего сдвинуть один было нельзя, не сдвинув остальные.

// С какого остатка на экране появляется таймер.
export const TIMER_VISIBLE_SECONDS = 60 * 5;

// То же для консультации, где сработает автопродление: деньги спишутся сами, продлевать
// вручную не нужно, и обратный отсчёт за пять минут до конца торопил бы клиента без повода.
// По макету таймер приходит за полторы минуты — как предупреждение о конце оплаченного
// времени, а не как призыв к действию.
export const TIMER_VISIBLE_WITH_AUTO_RENEWAL_SECONDS = 90;

// С какого остатка таймер становится красным. Порог общий для обоих режимов и больше порога
// появления, поэтому таймер и там, и там появляется сразу красным.
export const TIMER_WARNING_SECONDS = 60 * 5;

// С какого остатка открыто окно ручного продления. Наружу уходит колбэком и управляет
// появлением шторки. Момент автосписания к нему не привязан: он свой и живёт
// в chat/autoRenewal/constants.
export const RENEWAL_WINDOW_SECONDS = 60 * 5;
